export const datacenters = {
  title: 'Our Datacenters',
  subtitle: 'State-of-the-art facilities with premium connectivity',
  milan: {
    name: 'Milan DC1',
    provider: 'Seeweb',
    address: 'Via Caldera 21',
    city: '20153 Milano (MI), Italy',
    features: {
      network: {
        title: 'Network',
        description: 'Multiple 10G connections'
      },
      security: {
        title: 'Security',
        description: 'DDoS Protection'
      },
      power: {
        title: 'Power',
        description: 'Redundant Power'
      },
      monitoring: {
        title: 'Monitoring',
        description: '24/7 Security'
      }
    }
  },
  falkenstein: {
    name: 'Falkenstein DC1',
    provider: 'Hetzner Online GmbH',
    address: 'Am Datacenter-Park 1',
    city: '08223 Falkenstein/Vogtland, Germany',
    features: {
      network: {
        title: 'Network',
        description: 'SynthoNetwork 10G'
      },
      security: {
        title: 'Security',
        description: 'DDoS Protection'
      },
      power: {
        title: 'Power',
        description: 'Redundant Power'
      },
      storage: {
        title: 'Storage',
        description: 'NVMe Storage'
      }
    }
  }
};